import { AsyncPipe, JsonPipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { WrapperComponent } from '@shared/ui/components';
import { AuthService, UIService } from '@shared/utils';

@Component({
  standalone: true,
  selector: 'reza-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, JsonPipe, UpperCasePipe, RouterLink, WrapperComponent],
})
export class HeaderComponent {
  @HostBinding('class.is-test')
  get isTestEnvironmentClass() {
    return this.isTest;
  }

  isTest = this.uiService.isTestEnv;
  user$ = this.authService.user$;

  constructor(private uiService: UIService, private authService: AuthService, private router: Router) {
    this.authService.checkAuthAndLoadUser();
  }

  logout() {
    this.authService.logout();
  }
  login() {
    this.router.navigate(['/login']);
  }
}
